const meta = {
  id:          'dnd5e2024',
  name:        'D&D 5.5e 2024',
  shortName:   'D&D 5e',
  description: 'Dungeons & Dragons 5th Edition (2024)',
  iconId:      'system.dnd5e2024',
  order:       0,
};

export default meta;
